var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 521.58 403.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{stroke-width:0px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "m145.28,232.22L9.17,153.63c-12.22-7.06-12.22-24.69,0-31.75L215.97,2.48c12.22-7.06,27.5,1.76,27.5,15.87v49c61.59,3.72,128.79,33.4,184.08,86.83,76.79,74.21,108.59,172.97,87.82,249.51-4.57-58-41.24-118.53-102.22-158.13-55.07-35.77-117.67-46.48-169.68-33.92v45.5c0,14.11-15.28,22.93-27.5,15.87l-41.63-24.04-29.06-16.77Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/LinkArrow.70c99ee7cb4b1f5966f487e2550da7ff.svg";
export { ForwardRef as ReactComponent };